require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/floors/reviews/user-reviews.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/floors/reviews/user-reviews.legacy.js
// module id = 692
// module chunks = 31